import { ReactNode, useEffect, useState } from 'react'
import Popover from '@mui/material/Popover'
import Box from '@mui/material/Box'
import Icon from '@mui/material/Icon'

import { sharedColors } from '../../modules/shared/sharedColors'

type Props = {
    children?: ReactNode
    text?: ReactNode
    preventDefaultClick?: boolean
    style?: React.CSSProperties
    iconType?: string
    iconClassName?: string
    iconFontSize?: number
    iconColor?: string
    iconMarginLeft?: number
}

const VyneTooltip = (props: Props) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

    const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
        if (props.preventDefaultClick) {
            event.stopPropagation()
        }
        setAnchorEl(event.currentTarget)
    }

    const handleClose = (event: MouseEvent) => {
        const popoverContent = document.querySelector('#popover-content')
        const target = event.target as HTMLElement
        const isLinkClick = target.tagName === 'A' || target.closest('a')

        if ((popoverContent && popoverContent.contains(target)) || isLinkClick) {
            return
        }
        setAnchorEl(null)
    }

    useEffect(() => {
        if (anchorEl) {
            document.addEventListener('mousedown', handleClose)
        } else {
            document.removeEventListener('mousedown', handleClose)
        }
        return () => {
            document.removeEventListener('mousedown', handleClose)
        }
    }, [anchorEl])

    const isOpen = Boolean(anchorEl)

    return (
        <>
            <Popover
                open={isOpen}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            backgroundColor: 'transparent',
                            boxShadow: 'none',
                        },
                    },
                }}
            >
                <Box
                    id="popover-content"
                    style={props.style}
                    sx={{
                        backgroundColor: sharedColors.black,
                        borderRadius: '4px',
                        color: sharedColors.white,
                        fontSize: '14px',
                        fontWeight: 400,
                        border: `1px solid ${sharedColors.black}`,
                        lineHeight: '18px',
                        height: 'auto',
                        padding: '8px',
                        maxWidth: '272px',
                        boxShadow: 'none',
                    }}
                >
                    {props.children || props.text}
                </Box>
                <Box
                    sx={{
                        width: 0,
                        height: 0,
                        borderLeft: '8px solid transparent',
                        borderRight: '8px solid transparent',
                        borderTop: `8px solid ${sharedColors.black}`,
                        bottom: '14px',
                        left: 'calc(50% - 8px)',
                        margin: '0 auto',
                    }}
                />
            </Popover>
            {props.iconType ? (
                <Icon
                    onClick={handleOpen}
                    className={props.iconClassName}
                    style={{
                        fontSize: props.iconFontSize || 16,
                        cursor: 'pointer',
                        color: props.iconColor || sharedColors.characterSecondary,
                        marginLeft: props.iconMarginLeft || 0,
                    }}
                >
                    {props.iconType}
                </Icon>
            ) : (
                <Icon
                    onClick={handleOpen}
                    className={props.iconClassName}
                    style={{
                        fontSize: props.iconFontSize || 16,
                        cursor: 'pointer',
                        color: props.iconColor || sharedColors.characterSecondary,
                        marginLeft: props.iconMarginLeft || 0,
                    }}
                >
                    info
                </Icon>
            )}
        </>
    )
}

export default VyneTooltip
